import { useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function CheckboxWithMenu({
  checked,
  indeterminate,
  onChange,
  options,
  onOptionSelect,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          bgcolor: !indeterminate && !checked ? "#ededed" : "#f5f5f5",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <Checkbox
          checked={checked}
          indeterminate={indeterminate}
          onChange={onChange}
          sx={{ p: 0.75 }}
        />

        <IconButton
          size="small"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{ borderRadius: 1, ml: "-10px" }}
          disabled={!indeterminate && !checked}
        >
          <ArrowDropDownIcon fontSize="small" />
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {options.map((opt) => (
          <MenuItem
            key={opt.value}
            onClick={() => {
              onOptionSelect && onOptionSelect(opt);
              setAnchorEl(null);
            }}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
